import { createLazyComponent, LazyModule, LazyImport, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarItemContextMenu"*/ './lazyIndex')
);

// Lazy-load components
export var CalendarItemContextMenu = createLazyComponent(
    lazyModule,
    m => m.CalendarItemContextMenu
);

// Export from owa-persona
export const lazyInitializeLivePersonaCard = new LazyImport(
    lazyModule,
    m => m.initializeLivePersonaCard
);
export const lazyPersonaControlStore = new LazyImport(lazyModule, m => m.personaControlStore);
export const lazyInitializeLivePersonaCardForBirthdayEvent = new LazyAction(
    lazyModule,
    m => m.initializeLivePersonaCardForBirthdayEvent
);
